export default "__VITE_ASSET__ChaMPMOz__"